import { Link } from "wouter";
import { scrollToPageTop } from "@/components/HelioLogoMark";
import SectionLink from "@/components/powlo/SectionLink";
import { useFinanceConfig } from "@/api/hooks";
import { phoenixFooterDisclosure } from "@/utils/phoenixDisclosure";

const SCROLL_TOP_HREFS = new Set([
  "/methodology",
  "/about",
  "/blog",
  "/faq",
  "/contact",
  "/privacy",
  "/terms",
  "/cookies",
]);
import { COMPANY_ADDRESS, COMPANY_NUMBER, LEGAL_NAME, SUPPORT_EMAIL, SUPPORT_PHONE } from "@/constants/company";

const platform = [
  { href: "/", label: "Home" },
  { href: "/#check", label: "Get my Energy Plan" },
  { href: "/#example", label: "Example plan" },
  { href: "/blog", label: "Insights" },
];
const powloLinks = [
  { href: "/methodology", label: "Home Power Score methodology" },
  { href: "/network", label: "Powlo installer network" },
  { href: "/about", label: "About" },
];
const support = [
  { href: "/faq", label: "FAQ" },
  { href: "/contact", label: "Contact" },
  { href: "/privacy", label: "Privacy" },
  { href: "/terms", label: "Terms" },
  { href: "/cookies", label: "Cookies" },
];

export default function PowloFooter() {
  const { data: financeConfig } = useFinanceConfig();
  const disclosure = phoenixFooterDisclosure(financeConfig);

  return (
    <footer className="flex flex-col gap-12 bg-powlo-navy px-5 pb-10 pt-16 text-[#C9D1DE] sm:px-8 lg:px-20">
      <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1fr]">
        <div className="flex flex-col items-start gap-4 self-start text-left">
          <img src="/powlo-logo-lime.svg" alt="Powlo" className="h-7 w-auto self-start" />
          <p className="m-0 text-lg leading-relaxed text-white">Solar, simplified.</p>
          <div className="text-sm text-[#8FA0B8]">
            {COMPANY_ADDRESS.short}
            <br />
            {LEGAL_NAME} · Company No. {COMPANY_NUMBER} · {SUPPORT_PHONE} · {SUPPORT_EMAIL}
          </div>
        </div>
        <FooterCol title="Platform" links={platform} />
        <FooterCol title="Powlo" links={powloLinks} />
        <FooterCol title="Support" links={support} />
      </div>
      {disclosure ? (
        <p className="m-0 max-w-4xl text-base leading-relaxed text-white">{disclosure}</p>
      ) : null}
      <div className="border-t border-powlo-navy-light pt-6 text-sm text-[#8FA0B8]">
        © {new Date().getFullYear()} Powlo Ltd. All rights reserved.
      </div>
    </footer>
  );
}

function FooterCol({ title, links }: { title: string; links: { href: string; label: string }[] }) {
  return (
    <div className="flex flex-col gap-2">
      <div className="mb-2 text-xs font-bold tracking-widest text-white">{title.toUpperCase()}</div>
      {links.map((link) =>
        link.href.includes("#") ? (
          <SectionLink key={link.href} href={link.href} className="flex min-h-[32px] items-center text-base text-[#C9D1DE] no-underline hover:text-white">
            {link.label}
          </SectionLink>
        ) : (
          <Link
            key={link.href}
            href={link.href}
            className="flex min-h-[32px] items-center text-base text-[#C9D1DE] no-underline hover:text-white"
            onClick={SCROLL_TOP_HREFS.has(link.href) ? scrollToPageTop : undefined}
          >
            {link.label}
          </Link>
        ),
      )}
    </div>
  );
}
